import React from 'react';
import styled from 'styled-components';

import { colors } from 'helpers/ColorHelper';

const StyledButton = styled.button`
  color: ${props => (props.disabled ? colors.BATTLESHIP_GREY : props.accentColor)};
  font-size: 14px;
  font-family: 'Circular-Bold', 'Circluar', sans-serif;
  padding: 8px 24px;
  border-radius: 16px;
  border: none;
  background-color: transparent !important;
  &:active {
    background-color: ${colors.BLUEISH_GRAY};
  }
`;

const CtaCard = ({ accentColor = colors.ULTRAMARINE_BLUE, children, ...rest }) => {
  return (
    <StyledButton accentColor={accentColor} {...rest}>
      {children}
    </StyledButton>
  );
};

export default CtaCard;
